import { useState } from "react"

import { TextField } from "@mui/material"
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import { ThemeProvider } from "@mui/material/styles"

import { baseTheme, darkTheme } from "@/themes"
import { requestSilentNoRetry } from "@/Api"   

export default function ConfirmPassword({ open, setOpen, successCallback, email }) {
    const themeMode = localStorage.getItem("themeMode") || "light"

    const [ password, setPassword ] = useState("")
    const [ error, setError ] = useState("")
    const [ loading, setLoading ] = useState(false)

    const stopPropagation = (event) => {
        event.stopPropagation()
    }

    const handleCancel = (event) => {
        event.stopPropagation()
        setOpen(false)
        setPassword("")
        setError("")
    }

    const handleSubmit = (event) => {
        event.stopPropagation()

        if (password.trim() === "") {
            return
        }

        setError("")
        setLoading(true)

        requestSilentNoRetry.post("login", {email, password, device_id: localStorage.getItem("deviceId")}, {withCredentials: true}).then(response => {  
            setOpen(false)
            successCallback()
        }).catch(error => {
            const detail = error?.response?.data?.detail
            setError(typeof detail === "string" ? detail : "Invalid password.")
        }).finally(() => {
            setLoading(false)
        })
    }
    return (
        <ThemeProvider theme={themeMode == "dark" ? darkTheme : baseTheme}>
            <Dialog
                open={open}
                onClose={handleCancel}
            >
                <DialogTitle onClick={stopPropagation}>Confirm Password</DialogTitle>
                <DialogContent dividers onClick={stopPropagation}>
                    <p style={{marginTop: "0"}}>This action is sensitive and requires reauthentication.</p>                   

                    <TextField
                        label="Password"
                        type="password"
                        variant="filled"
                        fullWidth
                        InputProps={{
                            disableUnderline: true,
                        }}
                        value={password}
                        onInput={(event) => setPassword(event.target.value)}
                    />

                    {error && <p style={{color: "red"}}>{error}</p>}
                </DialogContent>
                <DialogActions onClick={stopPropagation}>
                    { loading ? (
                        <CircularProgress size={30} sx={{ marginRight: "12px"}} />
                    ) :  null }
                    
                    <Button variant="contained" onClick={handleCancel} color="secondary">Cancel</Button>
                    <Button variant="contained" onClick={handleSubmit} color="primary">Confirm</Button>
                </DialogActions>
            </Dialog>
        </ThemeProvider>
    )
}
